(async () => {

  const { Fancybox } = await import("@fancyapps/ui");
  class LocalizationForm extends HTMLElement {
    constructor() {

      super();

      this.elements = {
        input: this.querySelectorAll('input[name="country_code"], input[name="language_code"]'),
        panel: this.querySelectorAll('ul'),
      };

      this.elements.panel.forEach((panel) => {
        panel.querySelectorAll('li').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      });

      Fancybox.bind("[data-fancybox=market-switcher]", { animated: true });
    }

    onItemClick(event) {
      const item = event.currentTarget;
      const collapsible = item.closest('collapsible-element');
      const collapsibleType = collapsible.dataset.type;

      const input = [...this.elements.input].find(input => input.name === collapsibleType);
      if (input) input.value = item.dataset.value;

      const currentName = collapsible.querySelector('[data-current-name]');
      if (currentName) currentName.textContent = item.textContent.trim();

      if (collapsibleType === 'country_code') {
        const newFlag = item.querySelector('img');
        const currentCountryFlag = collapsible.querySelector('.circle-flag');

        if (currentCountryFlag && newFlag) {
          currentCountryFlag.src = '';
          currentCountryFlag.srcset = '';
          currentCountryFlag.src = newFlag.src;
          currentCountryFlag.srcset = newFlag.srcset || '';
          currentCountryFlag.alt = item.textContent.trim();
          currentCountryFlag.classList.remove('hidden');
        }
      }

      collapsible.toggle(collapsible.querySelector('[data-collapsible-group]'));
    }
  }
  customElements.define('localization-form', LocalizationForm);
})();
